export default function PropertyTable({ properties, onEdit, onDelete }) {

  if (properties.length === 0)
    return (
      <p className="text-gray-500 text-center">
        No hay propiedades
      </p>
    );

  return (
    <div className="overflow-x-auto">

      <table className="w-full border rounded-lg overflow-hidden">

        <thead className="bg-gray-100">

          <tr>
            <th className="p-3 text-left">Título</th>
            <th className="p-3 text-left">Ubicación</th>
            <th className="p-3 text-left">Precio</th>
            <th className="p-3 text-left">Tipo</th>
            <th className="p-3 text-left">Destacada</th>
            <th className="p-3 text-left">Acciones</th>
          </tr>

        </thead>

        <tbody>

          {properties.map((p) => (

            <tr
              key={p.id}
              className="border-t hover:bg-gray-50"
            >

              <td className="p-3 font-medium">
                {p.title}
              </td>

              <td className="p-3">
                {p.location}
              </td>

              <td className="p-3 font-semibold text-indigo-600">
                ${p.price}
              </td>

              <td className="p-3">
                {p.type}
              </td>

              <td className="p-3">
                {p.featured ? "⭐ Sí" : "No"}
              </td>

              <td className="p-3 flex gap-2">

                <button
                  onClick={() => onEdit(p)}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                >
                  Editar
                </button>

                <button
                  onClick={() => onDelete(p.id)}
                  className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                >
                  Eliminar
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}